import React from 'react';
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from '../../interfaces/commonProps';
import { useSpacing } from '../..';
import { StyledCircularLoader, StyledContainer, StyledValue, StyledProgressBar, StyledProgressBarTrain, circularLoaderSizes, StyledCircularTrain, StyledCircularTrack, } from './Loader.styles';
import { loaderPropTypes } from './Loader.types';
export const Loader = React.forwardRef(({ size = 'large', variant = 'circular', monochrome = false, value = null, displayValue, ...restProps }, ref) => {
    let determinate = false;
    let progress;
    if (typeof value === 'number') {
        determinate = true;
        value = Math.max(Math.min(Math.round(value), 100), 0);
        displayValue = displayValue || value.toString();
        progress = value / 100;
    }
    const progressType = determinate
        ? 'determinate'
        : 'continuous';
    const contextualProps = {
        ...(typeof value === 'number' && {
            'aria-valuenow': value,
            'aria-valuemin': 0,
            'aria-valuemax': 100,
        }),
        ...(displayValue && { 'aria-valuetext': displayValue }),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
        ...pickComponentCommonProps(restProps),
    };
    return (React.createElement(StyledContainer, { ...contextualProps, monochrome: monochrome, outerSpacing: useSpacing(restProps), progress: progress, progressType: progressType, ref: ref, role: "progressbar", size: size, title: displayValue, variant: variant }, (() => {
        switch (variant) {
            case 'circular': {
                const dimensions = circularLoaderSizes[progressType][size];
                const radius = dimensions.diameter / 2;
                const svgCircleParameters = {
                    cx: radius,
                    cy: radius,
                    r: radius - dimensions.stroke / 2,
                };
                return (React.createElement(React.Fragment, null,
                    React.createElement(StyledCircularLoader, { progressType: progressType, viewBox: `0 0 ${dimensions.diameter} ${dimensions.diameter}` },
                        React.createElement(StyledCircularTrack, { ...svgCircleParameters }),
                        React.createElement(StyledCircularTrain, { progressType: progressType, ...svgCircleParameters })),
                    determinate && (React.createElement(StyledValue, { role: "presentation", size: size }, displayValue))));
            }
            case 'linear':
                return (React.createElement(StyledProgressBar, null,
                    React.createElement(StyledProgressBarTrain, { progressType: progressType })));
        }
    })()));
});
Loader.propTypes = loaderPropTypes;
Loader.displayName = 'Loader';
//# sourceMappingURL=Loader.js.map